import React, {useEffect, useState} from 'react'
import { inputTypes } from '../../../libs/react-mpk/config/constant'
import { FormWrapper } from '../../../libs/react-mpk/wrapper'
import t from 'counterpart'
import { inject, observer } from 'mobx-react'
import service from './VTransaksiItem.service'
import KategoriPPh25Service from '../../adminpajakku/kategoriPph25/KategoriPph25.service'
import TipePengecualianPajakService from '../../adminpajakku/tipePengecualianPajak/TipePengecualianPajak.service'
import Utils from '../../../libs/custom/Utils'
import AkunService from '../../master/Akun/Akun.service'
import KodeObjekPajakService from '../../adminpajakku/KodeObjekPajak/KodeObjekPajak.service'
import AsetService from '../Aset/Aset.service'
import TransaksiService from './Transaksi.service'
import LawanTransaksiService from '../../master/LawanTransaksi/LawanTransaksi.service'
import EntitasService from '../../master/Entitas/Entitas.service'
import ItemService from '../../master/Item/Item.service'
import { toast } from '../../../libs/react-mpk/services'
import { TabsWrapper } from '../../../libs/react-mpk/wrapper'
import TransaksiPajakTerutangTable from './TransaksiPajakTerutang.table'
import { Button, FontIcon, TextIconSpacing } from 'react-md'
import { DataForm } from '../../../libs/react-mpk/components'

const TransaksiAktivaTetapForm = ({envStore, match, history, sipStore, modalStore, navigationStore}) => {
  const { inputTypes, definition } = FormWrapper
  const [isEdit, setIsEdit] = useState(false)
  const [data, setData] = useState({loading: true, content: {}})
  const [entitasList, setEntitasList] = useState([])
  const [lawanTransaksiList, setLawanTransaksiList] = useState([])
  const [lawanTransaksiMap, setLawanTransaksiMap] = useState({})
  const [itemList, setItemList] = useState([])
  const [itemMap, setItemMap] = useState({})
  const [curData, setCurData] = useState({});

  // initial data
  useEffect(() => {
    async function initData() {
      await _getLawanTransaksi()
      await _getEntitasList()
      await _getItemList()
      if(match.params.id == 'baru') {
        setData({loading: false, content: {perusahaanId: sipStore.companyId, periodeFiskalId: sipStore.periodeId, dipungut: false, dpp:'0', pph: '0', transaksiAktivaTetapAkun__nilai: '0', transaksiAktivaTetapPengecualians: []}})
        return true
      }
      const res = await service.getOne(match.params.id)
      res.data.items = res.data.items.map(x => Utils.formSerialize(x))
      res.data = Utils.formSerialize(res.data)
      setIsEdit(true)
      setCurData(res.data);
      setData({loading: false, content:res.data})
    }
    initData()
  }, ['match.params.id'])

  async function _getLawanTransaksi() {
    var res = await LawanTransaksiService.get({size: 10000, 'perusahaanId.equals': sipStore.companyId})
    setLawanTransaksiList(res.data.map(x => ({value: x.id, label: x.nama})))
    setLawanTransaksiMap(res.data.reduce((pv, cv)=> {
      pv[cv.id] = cv
      return pv
    }, {}))
  }

  async function _getEntitasList() {
    var res = await EntitasService.get({size: 10000, 'perusahaanId.equals': sipStore.companyId})
    setEntitasList(res.data.map(x => ({value: x.id, label: x.nama})))
  }

  async function _getItemList() {
    var res = await ItemService.get({size: 10000, 'perusahaanId.equals': sipStore.companyId})
    setItemList(res.data.map(x => ({value: x.id, label: x.kode?`${x.kode} - ${x.nama}`: `${x.nama}`})))
    setItemMap(res.data.reduce((pv, cv)=> {
      pv[cv.id] = cv;
      return pv
    }, {}))
  }

  async function importItem() {
    modalStore.showConfirm({
      title: "Upload Barang/Jasa",
      children: (
        <DataForm
          baseId={"import-upload"}
          hideActionButton
          defaultData={{}}
          definitions={[
            {
              inputType: FormWrapper.inputTypes.FILE_INPUT,
              label: "File",
              key: "file",
              theme: "filled",
              style: { width: 200 },
            },
          ]}
          // submitLabel="Import Data"
          onSubmit={async (d, callback) => {
            var formData = new FormData();
            formData.set("file", d.file);
            var uploadRes = await service.http.post("/upload", formData);
            if (uploadRes.data) {
              var data = { ...curData };
              var importRes = await service.http.get(
                `/pembelian-item-import/${uploadRes.data.name}/${sipStore.companyId}`
              );

              var data = { ...curData };
              data.items = importRes.data;
              FormWrapper.reload("mod-form-sample", data);
              setCurData(data);
            }
            callback("Data berhasil di upload", false);
          }}
        />
      ),
      onSubmit: async (callback) => {
        const f = document.getElementById(`import-upload-form-trigger`);
        if (f) f.click();
        callback();
      },
    });
  }

  async function uploadAttachment() {
    modalStore.showConfirm({
      title: "Upload Attachment",
      children: (
        <DataForm
          baseId={"attachment-upload"}
          hideActionButton
          defaultData={{}}
          definitions={[
            {
              inputType: FormWrapper.inputTypes.FILE_INPUT,
              label: "File",
              key: "file",
              theme: "filled",
              style: { width: 200 },
            },
            {
              inputType: inputTypes.INPUT,
              label: "Keterangan",
              key: "keterangan",
              type: "text",
              width: "100%",
            },
          ]}
          // submitLabel="Import Data"
          onSubmit={async (d, callback) => {
            var formData = new FormData();
            formData.set("file", d.file);
            var uploadRes = await service.http.post(
              "/upload-attachment",
              formData
            );
            if (uploadRes.data) {
              var data2 = { ...curData };
              if (!data2.attachment) data2.attachment = [];
              data2.attachment.push({
                filename: uploadRes.data.name,
                originalFilename: uploadRes.data.origin,
                keterangan: d.keterangan,
              });
              console.log(data2, 'adsasd')
              FormWrapper.reload("mod-form-sample", data2);
              setCurData(data2);
            }
            callback("Data berhasil di upload", false);
          }}
        />
      ),
      onSubmit: async (callback) => {
        const f = document.getElementById(`attachment-upload-form-trigger`);
        if (f) f.click();
        callback();
      },
    });
  }


  const form =  (
    <FormWrapper
      noValidate
      showCommandbar={match.params.id == 'baru'}
      loading={data.loading}
      actions={[
        {
          label: 'Generate',
          iconClassName: 'mdi mdi-inbox-full',
          onClick: async () => {
            modalStore.showConfirm({
              children: 'Generate data pajak terutang?',
              onRequestClose: ()=> {modalStore.closeConfirm()},
              onSubmit: async (callback) => {
                await service.http.get(`/pos/${match.params.id}/generate`);
                toast.success(`Data pajak terutang telah di generate.`);
                callback()
              }
            })
          }
        }
      ]}
      backTo={'/onpremise/transaksi-penjualan'}
      baseId="mod-form-sample"
      title='Transaksi Penjualan'
      // hintMessage={t.translate('modules.form.hint.message')}
      hintShowIcon={false}
      defaultData={data.content}
      onChange={(newObj, key, value, parentKey, indexAtParent) => {
        if(key === 'posLawanTransaksi__sumberId') {
          var lt = lawanTransaksiMap[value]
          if(lt) {
            newObj.posLawanTransaksi__jenisPemungutPPh22 = ""
            newObj.posLawanTransaksi__nama = lt.nama
            newObj.posLawanTransaksi__nik = lt.nik
            newObj.posLawanTransaksi__npwp = lt.npwp
            newObj.posLawanTransaksi__pemungut = ""
            newObj.posLawanTransaksi__sumber = "LawanTransaksi"
            newObj.posLawanTransaksi__sumberId = lt.id
            newObj.posLawanTransaksi__tipeWajibPajak = lt.tipeWajibPajak
            newObj.posLawanTransaksi__domisiliWajibPajak = lt.domisiliWajibPajak
          }
        }
        if(key === 'itemId') {
          var item = itemMap[value]
          if(item) {
            newObj.items[indexAtParent].nama = item.nama
            newObj.items[indexAtParent].kode = item.kode
          }
        }

        if(key == 'hargaSatuan' || key == 'qty' || key == 'diskon') {
          newObj.items[indexAtParent][key] = parseInt(value)
          newObj.items[indexAtParent].hargaTotal = (parseInt(newObj.items[indexAtParent].qty)*parseInt(newObj.items[indexAtParent].hargaSatuan))-parseInt(newObj.items[indexAtParent].diskon)
          newObj.items[indexAtParent].dpp =newObj.items[indexAtParent].hargaTotal
        }
        setCurData(newObj);
      }}
      definitions={[
        // =====
        {
          inputType: inputTypes.SELECT,
          label: 'Entitas',
          key: 'entitasId',
          type: 'text',
          required: true,
          options: entitasList,
          validation: 'required',
          // disabled: isEdit,
        },
        {
          inputType: inputTypes.INPUT,
          label: 'Nomor Transaksi',
          key: 'nomor',
          type: 'text',
          width: '49%',
          style: {marginRight: '2%'},
          disabled: isEdit,
          validation: 'required'
        }, {
          inputType: inputTypes.DATEPICKER,
          label: 'Tanggal Transaksi',
          key: 'tanggal',
          width: '49%',
          // style: {marginRight: '2%'},
          validation: 'required'
        },
        {
          inputType: inputTypes.INPUT,
          label: 'Keterangan',
          key: 'keterangan',
          type: 'text',
          width: '100%'
        },
        {
          inputType: inputTypes.SELECT,
          label: 'Lawan Transaksi',
          key: 'posLawanTransaksi__sumberId',
          type: 'text',
          // width: '49%',
          // style: {marginRight: '2%'},
          disabled: isEdit,
          options: lawanTransaksiList
        },
        {
          inputType: inputTypes.INPUT_MASK_NUMBER,
          mask: '##.###.###.#-###.###',
          maskChar: '_',
          maskValue: 'string',
          label: 'NPWP Lawan Transaksi',
          key: 'posLawanTransaksi__npwp',
          type: 'text',
          width: '49%',
          style: {marginRight: '2%'},
          validation: 'required',
          disabled: true
        },
        {
          inputType: inputTypes.INPUT_MASK_NUMBER,
          mask: '################',
          maskChar: '_',
          maskValue: 'string',
          label: 'NIK Lawan Transaksi',
          key: 'posLawanTransaksi__nik',
          type: 'text',
          width: '49%',
          disabled: true,
          validation: [{required_if: ['posLawanTransaksi__tipeWajibPajak', "OP"]}],
          show: (d) => d.posLawanTransaksi__domisiliWajibPajak == 'DN'
        },
        {
          inputType: inputTypes.INPUT,
          // mask: '################',
          // maskChar: '_',
          // maskValue: 'string',
          label: 'Passport Lawan Transaksi',
          key: 'posLawanTransaksi__nik',
          type: 'text',
          width: '49%',
          disabled: true,
          validation: [{required_if: ['posLawanTransaksi__tipeWajibPajak', "OP"]}],
          show: (d) => d.posLawanTransaksi__domisiliWajibPajak == 'LN'
        },

        {
          inputType: FormWrapper.inputTypes.LIST,
          label: '# BARANG / JASA',
          key: 'items',
          // hintMessage: 'Daftar Tarif',
          layout: 'table',
          style: {minWidth: 1600},
          extraAction: () => {
            return (
              <>
                <Button
                  themeType="outline"
                  className="mpk-margin-S margin-right"
                  onClick={() => {
                    importItem();
                  }}
                >
                  <TextIconSpacing
                    icon={<FontIcon iconClassName="mdi mdi-plus" />}
                  >
                    Import
                  </TextIconSpacing>
                </Button>
              </>
            );
          },
          defaultData: {
            keterangan: '-',
            "diskon": 0,
            "dpp": 0,
            "hargaSatuan": 0,
            "hargaTotal": 0,
            "ppn": 0,
            "ppnBm": 0,
            "qty": 0,
            "tarifPpnBm": 0
          },
          definitions: [
            {
              inputType: FormWrapper.inputTypes.SELECT,
              label: 'Barang/Jasa',
              key: 'itemId',
              theme: 'filled',
              style: {width: 600},
              validation: 'required',
              options: itemList
            },
            {
              inputType: inputTypes.INPUT_MASK_NUMBER,
              label: 'Harga Satuan',
              key: 'hargaSatuan',
              theme: 'filled',
              thousandSeparator: '.',
              decimalSeparator: ',',
              isNumericString: true,
              validation: 'required|numeric',
              style: {width: 200},
            },
            {
              inputType: inputTypes.INPUT_MASK_NUMBER,
              label: 'QTY',
              key: 'qty',
              theme: 'filled',
              thousandSeparator: '.',
              decimalSeparator: ',',
              isNumericString: true,
              validation: 'required|numeric',
              style: {width: 200},
            },
            {
              inputType: inputTypes.INPUT_MASK_NUMBER,
              label: 'Diskon',
              key: 'diskon',
              theme: 'filled',
              thousandSeparator: '.',
              decimalSeparator: ',',
              isNumericString: true,
              validation: 'required|numeric',
              style: {width: 200},
            },
            {
              inputType: inputTypes.INPUT_MASK_NUMBER,
              label: 'Harga Total',
              key: 'hargaTotal',
              theme: 'filled',
              thousandSeparator: '.',
              decimalSeparator: ',',
              isNumericString: true,
              validation: 'required|numeric',
              style: {width: 200},
              disabled: true,
            },
            {
              inputType: inputTypes.INPUT_MASK_NUMBER,
              label: 'DPP',
              key: 'dpp',
              theme: 'filled',
              thousandSeparator: '.',
              decimalSeparator: ',',
              isNumericString: true,
              validation: 'required|numeric',
              style: {width: 200},
              // disabled: true,
            },
          ]
        },
        {
          inputType: FormWrapper.inputTypes.LIST,
          label: "# ATTACHMENT",
          key: "attachment",
          // hintMessage: 'Daftar Tarif',
          layout: "table",
          style: { minWidth: 1600 },
          hideAddButton: true,
          defaultData: {
            keterangan: "-",
            filename: "",
            originalFilename: "",
          },
          extraAction: () => {
            return (
              <Button
                themeType="outline"
                className="mpk-margin-S margin-right"
                onClick={() => {
                  uploadAttachment();
                }}
              >
                <TextIconSpacing
                  icon={<FontIcon iconClassName="mdi mdi-plus" />}
                >
                  Upload Attachment
                </TextIconSpacing>
              </Button>
            );
          },
          definitions: [
            {
              inputType: inputTypes.INPUT,
              label: "Nama file",
              key: "filename",
              type: "text",
              disabled: true,
              // width: "100%",
              style: { width: 200 },
            },
            {
              inputType: inputTypes.INPUT,
              label: "Nama file orifinal",
              key: "originalFilename",
              disabled: true,
              type: "text",
              // width: "100%",
              style: { width: 200 },
            },
            {
              inputType: inputTypes.INPUT,
              label: "Keterangan",
              key: "keterangan",
              type: "text",
              // width: "100%",
              style: { width: 200 },
            },
          ],
        },

        // {
        //   inputType: inputTypes.SELECT,
        //   label: 'Pilih Aset',
        //   key: 'transaksiAktivaTetapAset__asetid',
        //   type: 'text',

        //   required: true,
        //   validation: 'required',
        //   options:asetList,
        // }
        // -----
      ]}
      onSubmit={async (data, callback) => {
        var res = {}
        try {
          data.transaksiId = match.params.transaksiId
          data = Utils.formNormalize(data)
          // data.transaksiAktivaTetapAkun.akun = {
          //   id: data.transaksiAktivaTetapAkun__akunid
          // }
          data.items = data.items.map((x)=>  Utils.formNormalize(x))
          if(match.params.id == 'baru') {
            res = await service.post(data)
          } else {
            res = await service.put(data)
          }
          callback(t.translate('global.dataTelahDiSimpan'), false)
          history.push('/onpremise/transaksi-penjualan')
        } catch(e) {
          callback(e, true, false)
        }
      }}
    />
  )

  if(match.params.id != 'baru') {
    return <TabsWrapper
      title="Transaksi Penjualan"
      showCommandbar={true}
      baseId="mod-details-sample-aad"
      actions={[
        {label: 'Back', iconClassName:'mdi mdi-arrow-left', onClick:() => history.push('/onpremise/transaksi-penjualan')}
      ]}
      onChange={ (tab, d) => {
        navigationStore.redirectTo(`/onpremise/transaksi-penjualan/${match.params.id}/${tab.key}`)
        d()
      }}
      // tabs={tabs}
      tabs={[
        {
          label: 'Data',
          key: 'form',
          render: form
        },
        {
          label: 'Pajak',
          key: 'pajak-terutang',
          render: <TransaksiPajakTerutangTable jenisMap={{}} history={history} transaksiId={null} posId={match.params.id} />
        },
      ]}

    />
  } else {
    return form
  }
}

export default inject('envStore', 'sipStore', 'modalStore', 'navigationStore')(observer(TransaksiAktivaTetapForm))
